import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddLeadingZeroPipe } from './add-leading-zero.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        AddLeadingZeroPipe
    ],
    exports: [
        AddLeadingZeroPipe
    ]
})
export class AddLeadingZeroModule {}
